import { render, staticRenderFns } from "./shareRatioConfig.vue?vue&type=template&id=9d0674f0&scoped=true"
import script from "./shareRatioConfig.vue?vue&type=script&lang=js"
export * from "./shareRatioConfig.vue?vue&type=script&lang=js"
import style0 from "./shareRatioConfig.vue?vue&type=style&index=0&id=9d0674f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0674f0",
  null
  
)

export default component.exports